import React from 'react';
import { KeyDownEvent } from '../../../utils/eventKey';
import UpdateKRViewComp from './update-kr-view';
import { useTranslation } from 'react-i18next';

const OKRHeaderComp = (props) => {
    const {id, goal, firstname='', lastname='', teamName = '', days_left = 0, metrics=[]} = props.item;
    const { t } = useTranslation()

    return (
        <>
            <div className="updateKRGoalDet" data-testid={`updateKRGoalDet-${id}`}>
                <div className="displayInlineB updateKRGoalDiv">
                    <div className="updateKRGoalNameDiv">
                        <span role="heading" aria-level="2">
                            <span data-testid="objectives-updateKR-due" className="clickable" onClick={() => props.goalDetPage(id)}
                                id={`update-kr-obj-label-${id}`}
                                tabIndex="0"
                                role="button"
                                onKeyDown={(e) => { KeyDownEvent(e, () => props.goalDetPage(id))}}
                                style={{fontSize:"16px",fontWeight:"bold"}}
                            >
                                {goal}
                            </span>
                        </span>
                    </div>
                    <div className="updateKROwnerTeamDiv">
                        {`${firstname} ${lastname}${teamName ? `: ${teamName}` : ''}`}
                    </div>
                </div>
                <div className="updateKRRemainingDays displayInlineB">
                    {t('{{daysLeft}} days left', { daysLeft: parseInt(days_left) })}
                </div>
            </div>
            <UpdateKRViewComp
                key={`update-kr-view-${id}`}
                labelledBy={`update-kr-obj-label-${id}`}
                metrics={metrics}
                goalDetPage={props.goalDetPage}
                handEmoji={props.handEmoji}
                symbolEmoji={props.symbolEmoji}
                pplEmoji={props.pplEmoji}
                showEmoticonList={props.showEmoticonList}
                selMdId={props.selMdId}
                showEmoticon={props.showEmoticon}
                getAllOkrs={props.getAllOkrs}
                displayKRConfidence={props.displayKRConfidence}
                hideEmoticonList={props.hideEmoticonList}
            />
        </>
    )
}

export default OKRHeaderComp;